(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/services/favorites.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/services/favorites.js');
"use strict";

const FAVORITE_KEY = 'tickets-einstant-favorites';
const ONE_YEAR_IN_SECONDS = 365 * 24 * 60 * 60;
const getFavorites = async () => {
  const path = "/player/1/objectstore?keys=".concat(FAVORITE_KEY);
  try {
    var _data$items;
    const data = await svs.core.jupiter.callAsync({
      method: 'GET',
      path
    });
    const favoriteItem = (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.find(_ref => {
      let {
        key
      } = _ref;
      return key === FAVORITE_KEY;
    });
    const favorites = JSON.parse((favoriteItem === null || favoriteItem === void 0 ? void 0 : favoriteItem.value) || '[]');
    return favorites.filter((v, i, a) => a.indexOf(v) === i);
  } catch (e) {
    svs.eInstant.logger.warn("Could not fetch favorites - skip update");
    throw new Error(e === null || e === void 0 ? void 0 : e.message);
  }
};
const updateValue = function () {
  let currentFavoriteGameCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let gameCode = arguments.length > 1 ? arguments[1] : undefined;
  let remove = arguments.length > 2 ? arguments[2] : undefined;
  let newFavoriteGameCodes = [];
  if (remove) {
    newFavoriteGameCodes = currentFavoriteGameCodes.filter(code => code !== gameCode);
  } else {
    newFavoriteGameCodes = [gameCode, ...currentFavoriteGameCodes].filter((v, i, a) => a.indexOf(v) === i);
  }
  return JSON.stringify(newFavoriteGameCodes);
};
const setFavorite = async function (gameCode) {
  let currentFavoriteGames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let remove = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  try {
    if (!currentFavoriteGames.length) {
      currentFavoriteGames = await getFavorites();
    }
    const currentFavoriteGameCodes = currentFavoriteGames.map(_ref2 => {
      let {
        type
      } = _ref2;
      return type;
    }) || [];
    const newValue = updateValue(currentFavoriteGameCodes, gameCode, remove);
    return await svs.core.jupiter.callAsync({
      method: 'POST',
      path: '/player/1/objectstore',
      data: {
        key: FAVORITE_KEY,
        value: newValue,
        expires: ONE_YEAR_IN_SECONDS
      }
    });
  } catch (error) {
    throw new Error(error === null || error === void 0 ? void 0 : error.message);
  }
};
setGlobal('svs.eInstant.shared.services', {
  getFavorites,
  setFavorite
});

 })(window);